var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.9643 8.1501C13.9317 11.8059 11.1563 14.6253 7.9066 14.5963C4.65689 14.5674 1.9322 11.6989 1.9648 8.0431C1.99739 4.38729 4.7728 1.56788 8.02251 1.59686C11.2722 1.62584 13.9969 4.49429 13.9643 8.1501Z","stroke":"#382E2B","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M12.5 12.5L17.7358 17.9509","stroke":"#382E2B","strokeWidth":"2","strokeLinecap":"round","key":1})]);
}

Search.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = Search;

Search.default = Search;
